// extracted by mini-css-extract-plugin
export var header = "_wb-1";
export var maskBottom = "_wb-6";
export var maskMiddle = "_wb-7";
export var maskTop = "_wb-5";
export var root = "_wb-0";
export var scrollDownButton = "_wb-3";
export var scrollDownButtonHidden = "_wb-4";
export var viewport = "_wb-2";